// theme.js

import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1A2B6D'
    },
    secondary: {
      main: '#FF6A00'
    },
    background: {
      default: '#F9F9F9',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#333333',
      secondary: '#666666',
    },
    grey: {
      100: '#F0F0F0',
      200: '#E0E0E0',
    },
  },
  typography: {
    fontFamily: ['Inter', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    h1: {
      fontSize: '2rem',       // ~32px
      fontWeight: 700,
    },
    h2: {
      fontSize: '1.5rem',     // ~24px
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.25rem',    // ~20px
      fontWeight: 600,
    },
    subtitle1: {
      fontSize: '1rem',       // ~16px
      fontWeight: 500,
      color: '#666666',
    },
    body1: {
      fontSize: '0.9375rem',  // ~15px
      fontWeight: 400,
    },
    body2: {
      fontSize: '0.875rem',   // ~14px
      fontWeight: 400,
    },
    caption: {
      fontSize: '0.75rem',    // ~12px
      color: '#666666',
    },
  },
  shape: {
    borderRadius: 8, // Rounded card corners
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          padding: '16px',
          boxShadow: 'none',
          border: '1px solid #E0E0E0',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#FF6A00',
          height: '3px',
          borderRadius: '2px',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #F0F0F0',
          padding: '12px 16px',
        },
      },
    },
  },
});

export default theme;
